/**
 * Homepage product rows: prev/next arrows slide a full row at a time.
 * The centered gap is padding, so the first paint already matches the resting row.
 * Extra copies of the tiles sit at the end of the track so the last step
 * wraps into the first games instead of leaving a short leftover row.
 */
(function () {
  function gapPx(track) {
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap);
    return isNaN(gap) ? 8 : gap;
  }

  function itemSlots() {
    return 1;
  }

  function slotStridePx(track) {
    var gap = gapPx(track);
    var item = track.querySelector(".grid__item:not([data-ri-loop-clone])");
    if (!item) return 128;
    return item.getBoundingClientRect().width + gap;
  }

  function pads(viewport) {
    var cs = window.getComputedStyle(viewport);
    return {
      l: parseFloat(cs.paddingLeft) || 0,
      r: parseFloat(cs.paddingRight) || 0
    };
  }

  function visWidth(viewport) {
    var p = pads(viewport);
    return Math.max(0, viewport.clientWidth - p.l - p.r);
  }

  function rowsOf(carousel) {
    if (!carousel) return 1;
    return carousel.getAttribute("data-ri-rows") === "2" ? 2 : 1;
  }

  /*
   * Shelves marked data-ri-shelf-fit (New Games, Buy 2 Get 1) show every cover at one height, so widths follow the
   * case and differ (a DS case is wider than a Wii case). On a computer those rows count whole covers by their real
   * widths instead of the first cover's, center the covers that fit, and clip just around them, so a page never
   * shows half a cover. Phones keep their own swipe row.
   */
  function isFitShelf(carousel) {
    return !!carousel && carousel.hasAttribute("data-ri-shelf-fit") && !isPhoneShelf();
  }

  function fitWidth(carousel) {
    return carousel._viewport ? carousel._viewport.clientWidth : 0;
  }

  /* Room for covers: the row less 8px, so the clip always keeps 2px on the left for a lifted cover's border and
     6px on the right for its shadow. */
  function fitRoom(carousel) {
    return Math.max(0, fitWidth(carousel) - 8);
  }

  /* How many whole covers fit starting at index `start` (at least one). */
  function fitCountFrom(carousel, start) {
    var nodes = carousel._track.children;
    var gap = gapPx(carousel._track);
    var room = fitRoom(carousel);
    var used = 0;
    var n = 0;
    for (var i = start; i < nodes.length; i++) {
      var w = nodes[i].getBoundingClientRect().width;
      var next = used + (n ? gap : 0) + w;
      if (n && next > room) break;
      used = next;
      n += 1;
    }
    return Math.max(1, n);
  }

  /* How many whole covers fit ending just before index `end` (at least one). */
  function fitCountBefore(carousel, end) {
    var nodes = carousel._track.children;
    var gap = gapPx(carousel._track);
    var room = fitRoom(carousel);
    var used = 0;
    var n = 0;
    for (var i = end - 1; i >= 0; i--) {
      var w = nodes[i].getBoundingClientRect().width;
      var next = used + (n ? gap : 0) + w;
      if (n && next > room) break;
      used = next;
      n += 1;
    }
    return Math.max(1, n);
  }

  /* Every real cover fits on one page, so the row needs no arrows and no loop copies. */
  function allFit(carousel) {
    var items = realItems(carousel._track);
    if (!items.length) return true;
    var gap = gapPx(carousel._track);
    var used = 0;
    for (var i = 0; i < items.length; i++) used += (i ? gap : 0) + items[i].getBoundingClientRect().width;
    return used <= fitRoom(carousel);
  }

  function perPage(carousel) {
    var track = carousel._track;
    var viewport = carousel._viewport;
    if (!track || !viewport) return 1;
    if (isFitShelf(carousel)) return fitCountFrom(carousel, carousel._index || 0);
    var stride = slotStridePx(track);
    if (stride <= 0) return 1;
    var cols = Math.max(1, Math.floor((visWidth(viewport) + gapPx(track)) / stride));
    return cols * rowsOf(carousel);
  }

  function realItems(track) {
    return track.querySelectorAll(".grid__item:not([data-ri-loop-clone])");
  }

  function realCount(track) {
    return realItems(track).length;
  }

  function totalSlots(track) {
    var items = realItems(track);
    var n = 0;
    for (var i = 0; i < items.length; i++) n += itemSlots(items[i]);
    return n;
  }

  function offsetBefore(track, index) {
    var carousel = track.closest("[data-ri-home-carousel]");
    var rows = rowsOf(carousel);
    if (rows > 1) return Math.floor(index / rows) * slotStridePx(track);
    var nodes = track.children;
    var gap = gapPx(track);
    var x = 0;
    var last = Math.min(index, nodes.length);
    for (var i = 0; i < last; i++) {
      x += nodes[i].getBoundingClientRect().width + gap;
    }
    return x;
  }

  function indexAfterSlots(items, start, slotDelta) {
    var total = items.length;
    if (!total) return 0;
    var i = start;
    var remaining = Math.abs(slotDelta);
    var dir = slotDelta >= 0 ? 1 : -1;
    while (remaining > 0) {
      if (dir > 0) {
        var fwd = ((i % total) + total) % total;
        remaining -= itemSlots(items[fwd]);
        i += 1;
      } else {
        i -= 1;
        var back = ((i % total) + total) % total;
        remaining -= itemSlots(items[back]);
      }
    }
    return i;
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function clearClones(track) {
    track.querySelectorAll("[data-ri-loop-clone]").forEach(function (node) {
      node.remove();
    });
  }

  function cancelDeferred(carousel) {
    if (carousel._idleId && typeof cancelIdleCallback === "function") {
      cancelIdleCallback(carousel._idleId);
    }
    if (carousel._deferTimer) {
      clearTimeout(carousel._deferTimer);
    }
    carousel._idleId = 0;
    carousel._deferTimer = 0;
    carousel._deferScheduled = false;
  }

  function afterFirstPaint(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function warmImgs(root, priority) {
    if (!root) return;
    var imgs = root.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.getAttribute("src")) continue;
      img.loading = "eager";
      if (priority) img.setAttribute("fetchpriority", priority);
      if (!img.complete && typeof img.decode === "function") {
        img.decode().catch(function () {});
      }
    }
  }

  function warmAt(nodes, from, count, priority) {
    if (from < 0) return;
    for (var n = 0; n < count; n++) {
      var node = nodes[from + n];
      if (!node) continue;
      warmImgs(node, priority);
    }
  }

  function warmPages(carousel) {
    var track = carousel._track;
    if (!track) return;
    var nodes = track.children;
    var pp = perPage(carousel);
    var real = realCount(track);
    var start = carousel._index || 0;
    var windowSize = pp + 2;
    warmAt(nodes, start, windowSize, "low");
    warmAt(nodes, start + pp, windowSize, "low");
    if (start >= pp) {
      warmAt(nodes, start - pp, windowSize, "low");
    } else if (real > pp) {
      warmAt(nodes, real - pp, windowSize, "low");
    }
  }

  function deferWork(carousel) {
    if (carousel._deferScheduled) return;
    carousel._deferScheduled = true;
    afterFirstPaint(function () {
      var run = function () {
        carousel._idleId = 0;
        carousel._deferTimer = 0;
        if (!carousel._track) return;
        syncLoop(carousel);
        warmPages(carousel);
      };
      if (typeof requestIdleCallback === "function") {
        carousel._idleId = requestIdleCallback(run, { timeout: 1400 });
      } else {
        carousel._deferTimer = setTimeout(run, 320);
      }
    });
  }

  function stripCloneIds(node) {
    if (node.id) node.removeAttribute("id");
    var labeled = node.querySelectorAll("[id]");
    for (var i = 0; i < labeled.length; i++) labeled[i].removeAttribute("id");
  }

  function phoneSetWidth(track) {
    var items = realItems(track);
    if (!items.length) return 0;
    var firstAfter = track.querySelector('[data-ri-loop-clone="after"]');
    if (firstAfter) return firstAfter.offsetLeft - items[0].offsetLeft;
    var last = items[items.length - 1];
    return last.offsetLeft + last.offsetWidth - items[0].offsetLeft;
  }

  function syncPhoneLoop(carousel) {
    var track = carousel._track;
    if (!track) return;
    var items = realItems(track);
    if (items.length < 2) {
      clearClones(track);
      carousel._phoneLoopCount = 0;
      return;
    }
    var before = track.querySelector('[data-ri-loop-clone="before"]');
    var after = track.querySelector('[data-ri-loop-clone="after"]');
    if (before && after && carousel._phoneLoopCount === items.length) return;
    var viewport = carousel._viewport;
    var keepLeft = !before && viewport ? viewport.scrollLeft : null;
    clearClones(track);
    items = realItems(track);
    var fragBefore = document.createDocumentFragment();
    var fragAfter = document.createDocumentFragment();
    for (var i = 0; i < items.length; i++) {
      var copyBefore = items[i].cloneNode(true);
      copyBefore.setAttribute("data-ri-loop-clone", "before");
      copyBefore.setAttribute("aria-hidden", "true");
      stripCloneIds(copyBefore);
      fragBefore.appendChild(copyBefore);
      var copyAfter = items[i].cloneNode(true);
      copyAfter.setAttribute("data-ri-loop-clone", "after");
      copyAfter.setAttribute("aria-hidden", "true");
      stripCloneIds(copyAfter);
      fragAfter.appendChild(copyAfter);
    }
    track.insertBefore(fragBefore, track.firstChild);
    track.appendChild(fragAfter);
    carousel._phoneLoopCount = items.length;
    if (keepLeft != null) {
      carousel._riLoopJump = true;
      viewport.scrollLeft = keepLeft + phoneSetWidth(track);
      carousel._riLoopJump = false;
    }
    if (window.RICardScrub && typeof window.RICardScrub.init === "function") {
      window.RICardScrub.init(track);
    }
  }

  function normalizePhoneLoop(carousel) {
    if (!carousel || carousel._riCentering || carousel._riLoopJump) return;
    var viewport = carousel._viewport;
    var track = carousel._track;
    if (!viewport || !track) return;
    var width = phoneSetWidth(track);
    if (width < 8) return;
    var x = viewport.scrollLeft;
    var next = 0;
    if (x < width * 0.35) next = x + width;
    else if (x > width * 1.65) next = x - width;
    if (!next || Math.abs(next - x) < 1) return;
    carousel._riLoopJump = true;
    viewport.scrollLeft = next;
    carousel._riLoopJump = false;
  }

  function bindPhoneLoop(carousel) {
    if (!carousel || carousel._phoneLoopBound || !carousel._viewport) return;
    carousel._phoneLoopBound = true;
    carousel._viewport.addEventListener(
      "scroll",
      function () {
        carousel._riScrollAt = Date.now();
        if (carousel._phoneLoopFrame) return;
        carousel._phoneLoopFrame = requestAnimationFrame(function () {
          carousel._phoneLoopFrame = 0;
          normalizePhoneLoop(carousel);
        });
      },
      { passive: true }
    );
  }

  function syncLoop(carousel) {
    if (isPhoneShelf()) return;
    var track = carousel._track;
    if (!track) return;
    var items = realItems(track);
    var total = items.length;
    var pp = perPage(carousel);
    var slots = totalSlots(track);
    var fitShelf = isFitShelf(carousel);
    var fitsOnePage = fitShelf ? allFit(carousel) : slots <= pp;
    /* A fit shelf's page count changes from page to page, so its copies are keyed on whether the row loops at all;
       keyed on the count, they were rebuilt (and their pictures reloaded) at the start of a slide. */
    var key = fitShelf ? total + ":" + (fitsOnePage ? "fit" : "loop") : total + ":" + pp + ":" + slots;
    if (carousel._loopKey === key && (fitsOnePage || track.querySelector("[data-ri-loop-clone]"))) {
      return;
    }
    carousel._loopKey = key;
    clearClones(track);
    if (fitsOnePage) return;
    for (var i = 0; i < total; i++) {
      var clone = items[i].cloneNode(true);
      clone.setAttribute("data-ri-loop-clone", "1");
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    }
    if (window.RICardScrub && typeof window.RICardScrub.init === "function") {
      window.RICardScrub.init(track);
    }
  }

  function isPhoneShelf() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function startsAtFirst(carousel) {
    return carousel.getAttribute("data-ri-phone-start") === "first";
  }

  function centerPhoneShelf(carousel) {
    var viewport = carousel._viewport;
    if (!viewport || carousel._riUserScrolled || carousel._riExtended || !isPhoneShelf() || startsAtFirst(carousel)) return;
    var max = viewport.scrollWidth - viewport.clientWidth;
    if (max < 8) return;
    carousel._riCentering = true;
    var track = carousel._track;
    var target = Math.round(max / 2);
    /* The row prints fewer games than it used to and fetches the rest. data-ri-phone-center
       (in games) keeps the phone row opening on the same games as when it printed 16. */
    var hold = parseFloat(carousel.getAttribute("data-ri-phone-center"));
    var real = track && !isNaN(hold) ? realItems(track) : null;
    if (real && real.length) {
      var k = Math.min(Math.floor(hold), real.length - 1);
      var tile = real[k];
      var at = viewport.scrollLeft + tile.getBoundingClientRect().left - viewport.getBoundingClientRect().left + (hold - k) * tile.offsetWidth;
      target = Math.round(Math.max(0, Math.min(max, at - viewport.clientWidth / 2)));
    }
    viewport.scrollLeft = target;
    /* Land on a whole tile, not halfway through one: nudge to the nearest tile edge. */
    if (track) {
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var edge = viewport.getBoundingClientRect().left + pad;
      var best = null;
      var tiles = track.querySelectorAll(".grid__item");
      for (var i = 0; i < tiles.length; i++) {
        var d = tiles[i].getBoundingClientRect().left - edge;
        if (best === null || Math.abs(d) < Math.abs(best)) best = d;
      }
      if (best !== null && Math.abs(best) > 0.5) viewport.scrollLeft += best;
    }
    requestAnimationFrame(function () {
      carousel._riCentering = false;
    });
  }

  function armPhoneShelf(carousel) {
    var viewport = carousel._viewport;
    if (!viewport || carousel._riPhoneArmed) {
      centerPhoneShelf(carousel);
      return;
    }
    carousel._riPhoneArmed = true;
    viewport.addEventListener(
      'pointerdown',
      function () {
        carousel._riUserScrolled = true;
      },
      { passive: true }
    );
    centerPhoneShelf(carousel);
    requestAnimationFrame(function () {
      centerPhoneShelf(carousel);
    });
    viewport.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        centerPhoneShelf(carousel);
      }, { once: true });
    });
  }

  function paint(carousel, opts) {
    opts = opts || {};
    var track = carousel._track;
    var viewport = carousel._viewport;
    var prev = carousel._prev;
    var next = carousel._next;
    if (!track || !viewport) return;

    if (isPhoneShelf()) {
      carousel.classList.add('ri-home-carousel--native');
      track.style.transform = '';
      track.style.transition = '';
      syncPhoneLoop(carousel);
      bindPhoneLoop(carousel);
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      carousel.classList.add('is-ready');
      armPhoneShelf(carousel);
      return;
    }
    carousel.classList.remove('ri-home-carousel--native');

    if (!opts.skipClones) syncLoop(carousel);

    var pp = perPage(carousel);
    var slots = totalSlots(track);
    if (carousel._index == null || carousel._index < 0) carousel._index = 0;

    if (opts.instant) {
      track.style.transition = "none";
    } else {
      track.style.transition = "";
    }

    var x = -offsetBefore(track, carousel._index);
    var fit = isFitShelf(carousel);
    if (fit) {
      /* A cover's width is known once its picture arrives; measure the page again then. */
      if (!carousel._fitLoadBound) {
        carousel._fitLoadBound = true;
        track.addEventListener(
          "load",
          function (event) {
            if (!event.target || event.target.tagName !== "IMG") return;
            /* Mid-slide, wait for the slide to end (transitionend) rather than cut it short. */
            if (carousel.classList.contains("is-paging")) {
              carousel._fitPending = true;
              return;
            }
            clearTimeout(carousel._fitTimer);
            carousel._fitTimer = setTimeout(function () {
              paint(carousel, { instant: true });
            }, 60);
          },
          true
        );
      }
      /* Center the covers that fit and clip around them: window.RIShelfSide in sections/ri-home.liquid, the same
         function that placed the first page before this script loaded. */
      if (typeof window.RIShelfSide === "function") x += window.RIShelfSide(carousel, carousel._index);
    } else if (viewport.style.clipPath) {
      viewport.style.clipPath = "";
    }
    track.style.transform = x ? "translate3d(" + x + "px, 0, 0)" : "";

    if (opts.instant) {
      void track.offsetWidth;
      track.style.transition = "";
    }

    var singlePage = fit ? allFit(carousel) : slots <= pp;
    if (prev) prev.hidden = singlePage;
    if (next) next.hidden = singlePage;

    if (opts.warmNow) {
      warmPages(carousel);
    }
    placeStickers(carousel);
  }

  function placeStickers(carousel) {
    if (!carousel || rowsOf(carousel) > 1) return;
    var track = carousel._track;
    if (!track) return;
    var items = track.querySelectorAll(".grid__item");
    var start = carousel._index || 0;
    var count = perPage(carousel);
    var visible = [];
    var maxH = 0;
    var i;
    for (i = 0; i < count; i++) {
      var item = items[start + i];
      if (!item) continue;
      var media = item.querySelector(".card__media");
      if (!media) continue;
      var h = media.getBoundingClientRect().height;
      if (h < 8) continue;
      visible.push({ item: item, h: h, bottom: media.getBoundingClientRect().bottom });
      if (h > maxH) maxH = h;
    }
    if (maxH < 1) return;
    for (i = 0; i < visible.length; i++) {
      var entry = visible[i];
      var price = entry.item.querySelector(".ri-catalog-commerce, .ri-flyer-price");
      if (!price) continue;
      var shortfall = maxH - entry.h;
      var shift = 0;
      if (shortfall >= 36) {
        var box = price.getBoundingClientRect();
        var onArt = entry.bottom - box.top + (parseFloat(price.style.getPropertyValue("--ri-sticker-drop")) || 0);
        shift = Math.min((shortfall - 20) * 0.4, Math.max(0, onArt - 14), (box.height || 36) * 0.55);
        if (shift < 6) shift = 0;
      }
      var nextDrop = shift > 0 ? shift.toFixed(1) : "";
      var prevDrop = parseFloat(price.style.getPropertyValue("--ri-sticker-drop")) || 0;
      if (nextDrop && Math.abs(parseFloat(nextDrop) - prevDrop) < 1.5) continue;
      if (shift > 0) price.style.setProperty("--ri-sticker-drop", nextDrop + "px");
      else if (prevDrop) price.style.removeProperty("--ri-sticker-drop");
    }
  }

  function snapLoop(carousel) {
    var total = realCount(carousel._track);
    if (total <= 0) return;
    if (carousel._index < total && carousel._index >= 0) return;
    while (carousel._index >= total) carousel._index -= total;
    while (carousel._index < 0) carousel._index += total;
    paint(carousel, { instant: true, warmNow: true });
  }

  function go(carousel, delta) {
    var track = carousel._track;
    var items = realItems(track);
    var total = items.length;
    var pp = perPage(carousel);
    var slots = totalSlots(track);
    if (isFitShelf(carousel) ? allFit(carousel) : slots <= pp) return;
    if (isFitShelf(carousel) && delta < 0) {
      /* Back one page: the covers that fit just before this one (from the end of the row when at the start). */
      pp = fitCountBefore(carousel, carousel._index === 0 ? total : carousel._index);
    }

    if (reduceMotion()) {
      carousel._index = indexAfterSlots(items, carousel._index, delta * pp);
      while (carousel._index >= total) carousel._index -= total;
      while (carousel._index < 0) carousel._index += total;
      paint(carousel, { instant: true, warmNow: true });
      return;
    }

    if (delta < 0 && carousel._index === 0) {
      carousel._index = total;
      paint(carousel, { instant: true, warmNow: true });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          carousel.classList.add("is-paging");
          carousel._index = indexAfterSlots(items, total, -pp);
          paint(carousel, { warmNow: true });
        });
      });
      return;
    }

    carousel.classList.add("is-paging");
    carousel._index = indexAfterSlots(items, carousel._index, delta * pp);
    paint(carousel, { warmNow: true });
  }

  function waitFonts() {
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === "function") {
      return Promise.race([
        document.fonts.ready,
        new Promise(function (resolve) {
          setTimeout(resolve, 900);
        })
      ]);
    }
    return Promise.resolve();
  }

  function ensureHold(carousel) {
    var viewport = carousel._viewport;
    if (!viewport || viewport.querySelector(".ri-home-carousel__hold")) return;
    var hold = document.createElement("div");
    hold.className = "ri-home-carousel__hold";
    hold.setAttribute("aria-hidden", "true");
    var html = "";
    for (var i = 0; i < 8; i++) {
      html +=
        '<div class="ri-ticker__skel"><div class="ri-ticker__skel-media"></div></div>';
    }
    hold.innerHTML = html;
    viewport.appendChild(hold);
  }

  function firstPageImgs(carousel) {
    var track = carousel._track;
    if (!track) return [];
    var nodes = track.children;
    var pp = perPage(carousel);
    var start = carousel._index || 0;
    var imgs = [];
    var slots = 0;
    for (var i = start; i < nodes.length && slots < pp + 1; i++) {
      var node = nodes[i];
      if (!node || node.classList.contains("ri-ticker__skel")) continue;
      slots += itemSlots(node);
      var list = node.querySelectorAll("img");
      for (var j = 0; j < list.length; j++) {
        var img = list[j];
        var scrub = img.getAttribute("data-ri-scrub-img");
        if (scrub && scrub !== "0") continue;
        if (!img.getAttribute("src")) continue;
        imgs.push(img);
      }
    }
    return imgs;
  }

  function waitImgs(imgs, ms) {
    if (!imgs || !imgs.length) return Promise.resolve();
    var tasks = [];
    for (var i = 0; i < imgs.length; i++) {
      tasks.push(
        (function (img) {
          if (img.complete && img.naturalWidth) return Promise.resolve();
          if (typeof img.decode === "function") {
            return img.decode().catch(function () {});
          }
          return new Promise(function (resolve) {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          });
        })(imgs[i])
      );
    }
    return Promise.race([
      Promise.all(tasks),
      new Promise(function (resolve) {
        setTimeout(resolve, ms || 1400);
      })
    ]);
  }

  function markEnterIndex(carousel, offset) {
    offset = offset || 0;
    var items = realItems(carousel._track);
    var cap = Math.max(perPage(carousel), 1);
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains("ri-ticker__skel")) continue;
      items[i].style.setProperty("--ri-enter-i", String(offset + Math.min(n, cap - 1)));
      n += 1;
    }
    return Math.min(n, cap);
  }

  function homeCarousels() {
    return Array.prototype.slice
      .call(document.querySelectorAll("[data-ri-home-carousel]"))
      .sort(function (a, b) {
        return (+a.getAttribute("data-ri-home-row") || 0) - (+b.getAttribute("data-ri-home-row") || 0);
      });
  }

  function finishReveal(carousel) {
    deferWork(carousel);
  }

  function revealCarousel(carousel, offset) {
    var n = markEnterIndex(carousel, offset);
    carousel.classList.add("is-ready");
    carousel._hasRevealed = true;
    finishReveal(carousel);
    return offset + n + 1;
  }

  function flushHomeReveal(force) {
    var rows = homeCarousels();
    var offset = 0;
    for (var i = 0; i < rows.length; i++) {
      var carousel = rows[i];
      if (carousel._hasRevealed) {
        offset += Math.max(perPage(carousel), 1) + 1;
        continue;
      }
      if (!carousel._rowReady) {
        if (force) continue;
        return;
      }
      offset = revealCarousel(carousel, offset);
    }
  }

  function armHomeRevealFailsafe() {
    if (flushHomeReveal._t) return;
    flushHomeReveal._t = window.setTimeout(function () {
      flushHomeReveal(true);
    }, 2000);
  }

  function prepareReveal(carousel) {
    if (!carousel || !carousel._track) return;
    if (carousel._track.querySelector(".ri-ticker__skel") && !carousel._track.querySelector(".ri-catalog-card, .ri-flyer-card")) {
      carousel.classList.remove("is-ready");
      return;
    }
    warmAt(carousel._track.children, carousel._index || 0, perPage(carousel) + 1, "high");
    carousel._rowReady = true;
    carousel._hasRevealed = true;
    carousel.classList.add("is-ready");
    finishReveal(carousel);
  }

  /* Your Source column width: one function, window.RIFitSource, printed under the band in sections/ri-home.liquid
     so the first paint is already right. Called again here when the set changes or the window resizes. */
  function fitSource(carousel) {
    if (rowsOf(carousel) < 2) return;
    if (typeof window.RIFitSource === "function") window.RIFitSource(carousel);
  }

  function mount(carousel) {
    var track = carousel.querySelector("[data-ri-carousel-track]");
    var viewport = carousel.querySelector(".ri-home-carousel__viewport");
    if (!track || !viewport) return;

    carousel._track = track;
    carousel._viewport = viewport;
    carousel._prev = carousel.querySelector(".ri-home-carousel__arrow--prev");
    carousel._next = carousel.querySelector(".ri-home-carousel__arrow--next");
    fitSource(carousel);
    if (carousel._index == null) carousel._index = 0;
    carousel._loopKey = "";
    ensureHold(carousel);

    if (!carousel._bound) {
      carousel._bound = true;
      if (carousel._prev) {
        carousel._prev.addEventListener("click", function () {
          if (isPhoneShelf()) {
            var item = carousel._track.querySelector(".grid__item");
            var width = item ? item.getBoundingClientRect().width + 12 : 160;
            carousel._viewport.scrollBy({ left: -width, behavior: "smooth" });
            return;
          }
          go(carousel, -1);
        });
      }
      if (carousel._next) {
        carousel._next.addEventListener("click", function () {
          if (isPhoneShelf()) {
            var item = carousel._track.querySelector(".grid__item");
            var width = item ? item.getBoundingClientRect().width + 12 : 160;
            carousel._viewport.scrollBy({ left: width, behavior: "smooth" });
            return;
          }
          go(carousel, 1);
        });
      }
      track.addEventListener("transitionend", function (e) {
        if (e.target !== track) return;
        carousel.classList.remove("is-paging");
        snapLoop(carousel);
        if (carousel._fitPending) {
          carousel._fitPending = false;
          paint(carousel, { instant: true });
        }
      });
      track.addEventListener(
        "load",
        function (e) {
          if (!e.target || e.target.tagName !== "IMG") return;
          placeStickers(carousel);
        },
        true
      );
      if (typeof ResizeObserver !== "undefined") {
        carousel._lastWidth = viewport.clientWidth;
        var ro = new ResizeObserver(function () {
          var w = viewport.clientWidth;
          if (Math.abs(w - (carousel._lastWidth || 0)) < 1) return;
          carousel._lastWidth = w;
          fitSource(carousel);
          paint(carousel, { instant: true });
        });
        ro.observe(viewport);
        carousel._resizeObserver = ro;
      } else {
        window.addEventListener("resize", function () {
          fitSource(carousel);
          paint(carousel, { instant: true });
        });
      }
    }

    carousel._render = function () {
      paint(carousel, { instant: true });
    };
    paint(carousel, { instant: true, skipClones: true });
    prepareReveal(carousel);
  }

  function refresh(carousel) {
    if (!carousel) return;
    carousel._replay = !!carousel._hasRevealed;
    cancelDeferred(carousel);
    carousel.classList.remove("is-ready");
    carousel._index = 0;
    carousel._loopKey = "";
    if (carousel._track) clearClones(carousel._track);
    if (carousel._replay && carousel._viewport && startsAtFirst(carousel) && isPhoneShelf()) {
      carousel._viewport.scrollLeft = 0;
    }
    mount(carousel);
  }

  function productHref(node) {
    var link = node && node.querySelector('a[href*="/products/"]');
    if (!link) return "";
    return (link.getAttribute("href") || "").split("?")[0];
  }

  /* Adds games after the last real tile and rebuilds the loop copies. The covers
     on screen stay where they are. */
  function extend(carousel, nodes) {
    var track = carousel && carousel._track;
    var viewport = carousel && carousel._viewport;
    if (!track || !viewport || !nodes || !nodes.length) return;
    if (carousel.classList.contains("is-paging") || Date.now() - (carousel._riScrollAt || 0) < 250) {
      setTimeout(function () {
        extend(carousel, nodes);
      }, 300);
      return;
    }
    var items = realItems(track);
    var last = items[items.length - 1];
    if (!last) return;
    var seen = {};
    for (var s = 0; s < items.length; s++) seen[productHref(items[s])] = true;
    var frag = document.createDocumentFragment();
    for (var n = 0; n < nodes.length; n++) {
      var href = productHref(nodes[n]);
      if (href && seen[href]) continue;
      seen[href] = true;
      frag.appendChild(nodes[n]);
    }
    if (!frag.childNodes.length) return;

    var phone = isPhoneShelf();
    var anchor = null;
    var anchorLeft = 0;
    if (phone) {
      var left = viewport.getBoundingClientRect().left;
      var all = track.children;
      for (var i = 0; i < all.length; i++) {
        var r = all[i].getBoundingClientRect();
        if (r.right > left + 1) {
          anchor = all[i];
          anchorLeft = r.left;
          break;
        }
      }
      var kind = anchor && anchor.getAttribute("data-ri-loop-clone");
      if (kind) {
        var set = track.querySelectorAll('[data-ri-loop-clone="' + kind + '"]');
        var at = Array.prototype.indexOf.call(set, anchor);
        anchor = items[at] || null;
      }
    }

    track.insertBefore(frag, last.nextSibling);
    carousel._riExtended = true;

    if (phone) {
      carousel._phoneLoopCount = 0;
      syncPhoneLoop(carousel);
      if (anchor) {
        carousel._riLoopJump = true;
        viewport.scrollLeft += anchor.getBoundingClientRect().left - anchorLeft;
        carousel._riLoopJump = false;
      }
    } else {
      carousel._loopKey = "";
      paint(carousel, { instant: true });
    }
    if (window.RICardScrub && typeof window.RICardScrub.init === "function") {
      window.RICardScrub.init(track);
    }
  }

  function loadRest(carousel) {
    var url = carousel.getAttribute("data-ri-rest-url");
    if (!url || carousel._restLoading) return;
    carousel._restLoading = true;
    var max = parseInt(carousel.getAttribute("data-ri-rest-max"), 10) || 34;
    fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        return res.ok ? res.text() : "";
      })
      .then(function (html) {
        if (!html) return;
        var tpl = document.createElement("template");
        tpl.innerHTML = html;
        var host = tpl.content.querySelector(".ri-home-shelf-rest");
        if (!host) return;
        var nodes = Array.prototype.slice.call(host.children).filter(function (node) {
          return node.classList.contains("grid__item");
        });
        extend(carousel, nodes.slice(0, max));
      })
      .catch(function () {});
  }

  function armRest(carousel) {
    if (carousel._restArmed || !carousel.getAttribute("data-ri-rest-url")) return;
    carousel._restArmed = true;
    var start = function () {
      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(function () {
          loadRest(carousel);
        }, { timeout: 2000 });
      } else {
        setTimeout(function () {
          loadRest(carousel);
        }, 400);
      }
    };
    carousel.addEventListener("pointerenter", function () {
      loadRest(carousel);
    }, { once: true });
    if (typeof IntersectionObserver !== "function") {
      start();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.disconnect();
          start();
          return;
        }
      },
      { rootMargin: "400px 0px" }
    );
    io.observe(carousel);
  }

  function initAll() {
    document.querySelectorAll("[data-ri-home-carousel]").forEach(function (carousel) {
      if (carousel.querySelector("[data-ri-generator-track]")) return;
      mount(carousel);
      armRest(carousel);
    });
  }

  window.RIHomeCarousel = {
    mount: mount,
    refresh: refresh,
    extend: extend,
    init: initAll
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

(function () {
  var root = document.querySelector("[data-ri-franchise-colors]");
  if (!root) return;
  var colors = (root.getAttribute("data-ri-franchise-colors") || "").split("|").filter(Boolean);
  if (!colors.length) return;

  function columnCount() {
    var template = getComputedStyle(root).gridTemplateColumns || "";
    var count = template.split(" ").filter(Boolean).length;
    return count || 1;
  }

  function neighbors(index, cols, total) {
    var row = Math.floor(index / cols);
    var col = index % cols;
    var found = [];
    for (var dr = -1; dr <= 1; dr += 1) {
      for (var dc = -1; dc <= 1; dc += 1) {
        if (!dr && !dc) continue;
        var nextRow = row + dr;
        var nextCol = col + dc;
        if (nextRow < 0 || nextCol < 0 || nextCol >= cols) continue;
        var next = nextRow * cols + nextCol;
        if (next >= 0 && next < total) found.push(next);
      }
    }
    return found;
  }

  function blankPositions(count, cols) {
    var spots = [];
    if (!count || !cols) return { total: 0, spots: spots };
    var remainder = count % cols;
    var blanksNeeded = remainder === 0 ? 0 : cols - remainder;
    var total = count + blanksNeeded;
    var denom = blanksNeeded + 1;
    for (var b = 1; b <= blanksNeeded; b += 1) {
      var pos = Math.floor((b * total + Math.floor(denom / 2)) / denom);
      while (spots.indexOf(pos) !== -1) pos += 1;
      if (pos >= total) pos = total - 1;
      spots.push(pos);
    }
    return { total: total, spots: spots };
  }

  function layout() {
    var franchises = Array.prototype.slice.call(root.querySelectorAll("a.ri-home__franchise"));
    var blanks = Array.prototype.slice.call(root.querySelectorAll(".ri-home__franchise-blank"));
    var plan = blankPositions(franchises.length, columnCount());
    var total = plan.total;
    while (blanks.length < total - franchises.length) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "ri-home__franchise ri-home__franchise-blank";
      button.setAttribute("aria-label", "Change color");
      blanks.push(button);
    }
    var frag = document.createDocumentFragment();
    var franchiseIndex = 0;
    var blankIndex = 0;
    for (var i = 0; i < total; i += 1) {
      if (plan.spots.indexOf(i) !== -1 || franchiseIndex >= franchises.length) {
        frag.appendChild(blanks[blankIndex]);
        blankIndex += 1;
      } else {
        frag.appendChild(franchises[franchiseIndex]);
        franchiseIndex += 1;
      }
    }
    while (blankIndex < blanks.length) {
      var extra = blanks[blankIndex];
      blankIndex += 1;
      if (extra.parentNode) extra.parentNode.removeChild(extra);
    }
    root.appendChild(frag);
  }

  function paint() {
    var tiles = Array.prototype.slice.call(root.children);
    var cols = columnCount();
    var chosen = [];
    tiles.forEach(function (tile, index) {
      var banned = {};
      neighbors(index, cols, tiles.length).forEach(function (n) {
        if (chosen[n]) banned[chosen[n]] = true;
      });
      var color = colors[index % colors.length];
      for (var i = 0; i < colors.length; i += 1) {
        var candidate = colors[(index + i) % colors.length];
        if (!banned[candidate]) {
          color = candidate;
          break;
        }
      }
      chosen[index] = color;
      tile.style.setProperty("--ri-franchise-bg", color);
    });
    tiles.forEach(function (tile, index) {
      var banned = {};
      banned[chosen[index]] = true;
      neighbors(index, cols, tiles.length).forEach(function (n) {
        if (chosen[n]) banned[chosen[n]] = true;
      });
      var hover = colors[(colors.indexOf(chosen[index]) + 1) % colors.length];
      for (var i = 0; i < colors.length; i += 1) {
        var candidate = colors[(colors.indexOf(chosen[index]) + 1 + i) % colors.length];
        if (!banned[candidate]) {
          hover = candidate;
          break;
        }
      }
      tile.style.setProperty("--ri-franchise-hover", hover);
      tile.setAttribute("data-ri-franchise-color", String(colors.indexOf(chosen[index])));
    });
  }

  layout();
  paint();
  var resizeTimer = 0;
  var laidOutColumns = columnCount();
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var cols = columnCount();
      if (cols !== laidOutColumns) {
        laidOutColumns = cols;
        layout();
      }
      paint();
    }, 120);
  });

  root.addEventListener("click", function (event) {
    var tile = event.target.closest(".ri-home__franchise-blank");
    if (!tile || !root.contains(tile)) return;
    var tiles = Array.prototype.slice.call(root.children);
    var index = tiles.indexOf(tile);
    var cols = columnCount();
    var banned = {};
    neighbors(index, cols, tiles.length).forEach(function (n) {
      var bg = getComputedStyle(tiles[n]).getPropertyValue("--ri-franchise-bg").trim().toLowerCase();
      if (bg) banned[bg] = true;
    });
    var current = parseInt(tile.getAttribute("data-ri-franchise-color") || "0", 10);
    if (isNaN(current)) current = 0;
    var next = current;
    for (var step = 1; step <= colors.length; step += 1) {
      var candidate = (current + step) % colors.length;
      if (!banned[colors[candidate].toLowerCase()]) {
        next = candidate;
        break;
      }
    }
    var hoverBanned = {};
    hoverBanned[colors[next].toLowerCase()] = true;
    Object.keys(banned).forEach(function (key) {
      hoverBanned[key] = true;
    });
    var hover = (next + 1) % colors.length;
    for (var h = 1; h <= colors.length; h += 1) {
      var hoverIndex = (next + h) % colors.length;
      if (!hoverBanned[colors[hoverIndex].toLowerCase()]) {
        hover = hoverIndex;
        break;
      }
    }
    tile.setAttribute("data-ri-franchise-color", String(next));
    tile.style.setProperty("--ri-franchise-bg", colors[next]);
    tile.style.setProperty("--ri-franchise-hover", colors[hover]);
  });
})();
